import ServerApi from './$server.api'

export default {
    getSatProducts,
    getSatUnits
}

async function getSatProducts(query) {
    return await ServerApi.request('get', '/catalogs/sat/products', {query})
}

async function getSatUnits(query) {
    return await ServerApi.request('get', '/catalogs/sat/units', {query})
}
